module.exports = __webpack_public_path__ + "static/media/restaurant.23e13fb2.png";